import React from 'react';

const SOCIALS = [
  { href: 'https://www.linkedin.com/in/danielbradley2/', label: 'LinkedIn' },
  { href: 'https://x.com/DanielatOCN', label: 'X' },
  { href: 'https://www.youtube.com/@ourcloudnetwork', label: 'YouTube' },
  { href: 'https://ourcloudnetwork.com/', label: 'Blog' },
];

const About = () => {
  return (
    <div className="about">
      <section className="about-hero">
        <div className="about-avatar" aria-hidden="true">DB</div>
        <div className="about-hero-text">
          <span className="about-eyebrow">About the author</span>
          <h1 className="about-name">Daniel Bradley</h1>
          <p className="about-role">Microsoft MVP · Cloud &amp; Security</p>
          <div className="about-socials">
            {SOCIALS.map(s => (
              <a
                key={s.href}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="about-social-link"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="about-body">
        <p>
          Hi, I'm <strong>Daniel Bradley</strong>, a Microsoft MVP focused on identity,
          security and the wider Microsoft cloud. I built MicrosoftDocsTracker to solve a
          problem that many of us in IT face every day: staying up to date with the constant
          stream of changes across Microsoft's documentation.
        </p>
        <p>
          Microsoft ships changes daily across Entra, Intune, Graph, Microsoft 365 and
          Defender. Keeping track of it all manually is exhausting, so this tool watches the
          official documentation repositories and surfaces concise, AI-generated summaries of
          what actually changed, helping you stay informed without the noise.
        </p>
        <p>
          When I'm not building tools, I write about Microsoft cloud and security over at{' '}
          <a href="https://ourcloudnetwork.com/" target="_blank" rel="noopener noreferrer">
            ourcloudnetwork.com
          </a>{' '}
          and share updates on social media.
        </p>
      </section>

      <section className="about-projects">
        <h2 className="about-projects-title">Other projects</h2>
        <div className="about-projects-grid">
          <a
            href="https://msmessagecenter.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-project-card"
          >
            <span className="about-project-name">MS Message Center</span>
            <span className="about-project-desc">
              A community viewer for Microsoft 365 Message Center announcements.
            </span>
            <span className="about-project-arrow">Visit →</span>
          </a>
          <a
            href="https://msicons.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-project-card"
          >
            <span className="about-project-name">MS Icons</span>
            <span className="about-project-desc">
              A searchable library of Microsoft product and service icons.
            </span>
            <span className="about-project-arrow">Visit →</span>
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
